import { Mood, SecondaryMood } from '@peekapak/types/Mood';
import { GradeBand, classifyCheckin } from '@peekapak/types/EmotionsClassification';
import { DateRange, EmotionsReportClassroom } from '@peekapak/types/EmotionsReportRow';

export interface FeelingCount {
  feeling: Mood | SecondaryMood;
  count: number;
}

export interface SectionSummary {
  totalDownMoods: number;
  byFeeling: FeelingCount[];
}

export function buildSectionSummary(
  classrooms: EmotionsReportClassroom[],
  gradeBand: GradeBand,
  selectedRange: DateRange,
): SectionSummary {
  const countByFeeling = new Map<Mood | SecondaryMood, number>();

  for (const classroom of classrooms) {
    for (const student of classroom.students) {
      for (const checkin of student.checkins) {
        if (checkin.createdAt < selectedRange.start || checkin.createdAt > selectedRange.end) {
          continue;
        }
        if (classifyCheckin(checkin.feeling, gradeBand) === 'not-concerning') {
          continue;
        }
        countByFeeling.set(checkin.feeling, (countByFeeling.get(checkin.feeling) ?? 0) + 1);
      }
    }
  }

  const byFeeling = [...countByFeeling.entries()]
    .map(([feeling, count]) => ({ feeling, count }))
    .sort((a, b) => b.count - a.count);

  const totalDownMoods = byFeeling.reduce((sum, entry) => sum + entry.count, 0);

  return { totalDownMoods, byFeeling };
}
